import { adminHttpClient } from '../../commons/adminHttpClient'
import { Moment } from 'moment'

export type EndOfMonthNumbersReportFilter = {
  month: string
}

export const getEndOfMonthNumbersReport = (filter: EndOfMonthNumbersReportFilter): Promise<any> => {
  return adminHttpClient.get('/csi/reports/end-of-month-numbers', filter)
}
